import React from 'react';
import { useRegistration } from './RegistrationContext';
export const Header = () => {
  const {
    openPopup
  } = useRegistration();
  return <header className="mb-8" data-id="element-82">
      <div className="flex items-center justify-center mb-4" data-id="element-83">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs Logo" className="h-16 object-contain" data-id="element-84" />
      </div>
      <button onClick={openPopup} className="w-full bg-blue-50 p-3 rounded-lg mb-6 border-2 border-blue-300 hover:bg-blue-100 transition-colors cursor-pointer" data-id="element-85">
        <p className="text-center font-bold text-blue-700" data-id="element-86">
          GRATIS WEBINAR: SCHRIJF JE IN VOOR VANDAAG OF MORGEN
        </p>
      </button>
      <h1 className="text-2xl md:text-3xl font-bold text-center mb-6 text-blue-800 leading-tight" data-id="element-87">
        Hondengedragsdeskundige onthult: Er is een verborgen taalbarrière tussen
        jou en je hond die voorkomt dat jullie die magische, diepe verbinding
        hebben
      </h1>
      <div className="text-center mb-4 text-blue-600 font-semibold" data-id="element-88">
        15.000+ Nederlandse baasjes hebben al geleerd hoe ze deze doorbreken
      </div>
      <div className="text-center text-sm text-gray-600 mb-6" data-id="element-89">
        Door Amee de Bruijn, Gediplomeerd Hondengedragsconsultant
      </div>
      <div className="w-full mb-6" data-id="element-90">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aKFXUodCe3qiDP6wkKrCns/Scherm%C2%ADafbeelding_2025-08-15_om_15.31.25.png" alt="Close-up van een vrouw die liefdevol naar haar golden retriever kijkt" className="w-full h-auto rounded-lg shadow-md" data-id="element-91" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-92">
          Honden snappen vaak niet wat hun baasje bedoelt, omdat ze verkeerde
          signalen afgeven
        </p>
      </div>
      <div className="w-full h-[1px] bg-gray-200 my-6" data-id="element-93"></div>
    </header>;
};